import http from "../api/http";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

export default function AuthUser() {
  const navigate = useNavigate();

  const getToken = () => {
    return Cookies.get("token") || null;
  };

  const getUser = () => {
    const raw = Cookies.get("user");
    return raw ? JSON.parse(raw) : null;
  };

  const [token, setToken] = useState(getToken());
  const [user, setUser] = useState(getUser());

  const saveToken = (userData, tokenValue) => {
    Cookies.set("token", tokenValue, { expires: 1 });
    Cookies.set("user", JSON.stringify(userData), { expires: 1 });

    setToken(tokenValue);
    setUser(userData);

    navigate("/categories");
  };

  const handlelogout = async () => {
    try {
      if (user?.id) {
        await http.get(`/api/logout/${user.id}`);
      }
    } catch (err) {
      // ignore logout errors (token might already be invalid)
      console.error(err?.response?.data || err.message);
    }
  };

  const logout = async () => {
    await handlelogout();

    Cookies.remove("token");
    Cookies.remove("user");

    setToken(null);
    setUser(null);

    navigate("/login");
  };

  return {
    setToken: saveToken,
    token,
    user,
    getToken,
    http,
    logout,
  };
}
